import { Node } from '@tiptap/core';

export const VariableInput = Node.create({
  name: 'variableInput',
  group: 'inline',
  inline: true,
  atom: true, // single unit

  addAttributes() {
    return {
      variable: { default: null },
      value: { default: '' },
      placeholder: { default: '' },
      required: { default: false },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span.variable-input',
        getAttrs: (dom) => ({
          variable: dom.dataset.variable || null,
          value: dom.dataset.value || '',
          placeholder: dom.dataset.placeholder || '',
          required: dom.dataset.required || false,
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        class: 'variable-input',
        'data-variable': HTMLAttributes.variable,
        'data-value': HTMLAttributes.value,
      },
      HTMLAttributes.value || '', // fallback
    ];
  },

  addNodeView() {
    return ({ node, editor, getPos }) => {
      const wrapper = document.createElement('span');
      wrapper.classList.add('variable-input');
      wrapper.dataset.variable = node.attrs.variable;
      wrapper.style.display = 'inline-block';
      wrapper.style.maxWidth = '100%';
      wrapper.style.verticalAlign = 'middle';
      wrapper.style.border = 'none';
      wrapper.style.padding = '0';

      const editable = document.createElement('span');
      editable.classList.add('variable-editable');
      editable.contentEditable = 'true';
      editable.textContent = node.attrs.value || '';
      editable.dataset.placeholder = node.attrs.placeholder;

      const updatePlaceholder = () => {
        if (!editable.textContent) {
          editable.textContent = node.attrs.placeholder || '';
          editable.style.color = '#6a6765';
        } else if (editable.textContent === node.attrs.placeholder) {
          editable.style.color = '#6a6765';
        }
      };
      updatePlaceholder();

      const clearPlaceholderAndFocusInput = () => {
        editable.textContent = '';
        const measureSpan = document.createElement('span');
        measureSpan.classList.add('variable-input-measure');

        measureSpan.style.font = window.getComputedStyle(editable).font;
        measureSpan.textContent = node.attrs.placeholder;

        document.body.appendChild(measureSpan);
        const placeholderWidth = measureSpan.getBoundingClientRect().width + 8; // +padding
        document.body.removeChild(measureSpan);

        editable.style.minWidth = `${placeholderWidth}px`;
        editable.style.textDecoration = 'none';
        editable.style.borderBottom = '1px solid #6222E3';

        // Defer setting caret to ensure it stays at the start
        setTimeout(() => {
          const range = document.createRange();
          const sel = window.getSelection();
          range.setStart(editable, 0);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
          editable.focus();
        }, 0);
      };

      editable.addEventListener('input', () => {
        editable.style.color = '#6222E3';

        if (editable.textContent === '') {
          clearPlaceholderAndFocusInput();
          editable.style.borderBottom = '1px solid #6222E3';
        }
      });

      editable.addEventListener('focus', () => {
        wrapper.classList.add('selected');
        editable.style.textDecorationStyle = 'solid';

        if (editable.textContent === node.attrs.placeholder) {
          clearPlaceholderAndFocusInput();
        }
      });

      editable.addEventListener('blur', () => {
        wrapper.classList.remove('selected');
        editable.style.textDecoration = 'underline';
        editable.style.textDecorationStyle = 'dashed';
        editable.style.textDecorationColor = '#6222E3';
        editable.style.textUnderlineOffset = '4px';
        editable.style.borderBottom = 'none';
        if (!editable.textContent) {
          updatePlaceholder();
        }

        const { tr } = editor.state;
        tr.setNodeMarkup(getPos(), undefined, {
          ...node.attrs,
          value: editable.textContent === node.attrs.placeholder ? '' : editable.textContent,
        });
        editor.view.dispatch(tr);
      });

      wrapper.appendChild(editable);

      return {
        dom: wrapper,
        contentDOM: null,
        stopEvent: (event) => event.target === editable,
      };
    };
  },
});
